import { render, staticRenderFns } from "./forumList.vue?vue&type=template&id=e4cd4552&"
import script from "./forumList.vue?vue&type=script&lang=js&"
export * from "./forumList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports